import React from 'react'

export const LoadingIndicator = () => {
	return (
		<div>
			lädt...
		</div>
	)
}
